import { Stack, useTheme } from "@mui/material";
import { Pills } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";
import { SocialPostType } from "../../types/post.types";
import { getPostTypeColor, SOCIAL_POST_TYPE_VISUAL } from "../../utils/postType";

interface PostTypeBadgeProps {
    postType: SocialPostType;
}

export const PostTypeBadge = ({ postType }: PostTypeBadgeProps) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const visual = SOCIAL_POST_TYPE_VISUAL[postType];
    const color = getPostTypeColor(theme, visual.colorToken);

    return (
        <Pills
            variant="neutral"
            icon={visual.icon}
            label={t(visual.labelKey, visual.defaultLabel)}
            ChipProps={{
                sx: {
                    border: `1px solid ${color}40`,
                    backgroundColor: `${color}14`,
                    height: 28,
                    fontWeight: 600,
                    color,
                    "& .MuiChip-icon": {
                        color,
                    },
                },
            }}
        />
    );
};

export const PostTypeAccent = ({ postType }: PostTypeBadgeProps) => {
    const theme = useTheme();
    const visual = SOCIAL_POST_TYPE_VISUAL[postType];
    const color = getPostTypeColor(theme, visual.colorToken);

    return (
        <Stack
            aria-hidden
            sx={{
                width: 4,
                minWidth: 4,
                alignSelf: "stretch",
                borderRadius: "4px 0 0 4px",
                backgroundColor: color,
                flexShrink: 0,
            }}
        />
    );
};
